import * as React from 'react';
import './AdminDirectoryPages.scss';

interface IAdminDirectoryLayoutProps {
    title: string;
    subtitle: string;
    action?: React.ReactNode;
    children: React.ReactNode;
}

export default function AdminDirectoryLayout({ title, subtitle, action, children }: IAdminDirectoryLayoutProps) {
    return (
        <div className="admin-directory-page">
            <header className="admin-directory-header">
                <div>
                    <h2>{title}</h2>
                    <p>{subtitle}</p>
                </div>
                {action}
            </header>
            <div className="admin-directory-panel">{children}</div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/admin/sections/AdminDirectoryLayout.tsx